import Layout from '../components/Layout';

import logo1 from '../assets/1.png';
import logo2 from '../assets/2.png';
import logo3 from '../assets/3.png';

import { ReactComponent as Apple } from '../assets/apple.svg';
import { ReactComponent as Google } from '../assets/google.svg';
import SvgPetGeo from '../components/SvgPetGeo';
// import { ReactComponent as Rustore } from "../assets/rustore.svg";

const Home = () => {
	return (
		<Layout>
			<div className='main'>
				<div className='info'>
					<SvgPetGeo />

					<p className='info__text'>
						A mobile app that helps pets and brings pet owners together
					</p>

					<div className='stores'>
						<a
							className='store'
							href='https://apps.apple.com/us/app/petgeo/id6755123693'
							target='_blank'
							rel='noopener noreferrer'
						>
							<Apple />
						</a>

						<a
							className='store'
							href='https://play.google.com/store/apps/details?id=com.yuna.petgeo'
							target='_blank'
							rel='noopener noreferrer'
						>
							<Google />
						</a>

						{/* <a
              className="store"
              href="https://apps.rustore.ru/app/com.knois.Food"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Rustore />
            </a> */}
					</div>
				</div>

				<div className='screenshots'>
					<img src={logo1} alt='Screenshot' className='screenshot' />

					<img
						src={logo2}
						alt='Screenshot'
						className='screenshot screenshot-left'
					/>

					<img
						src={logo3}
						alt='Screenshot'
						className='screenshot screenshot-right'
					/>
				</div>
			</div>

			<div className='cards'>
				<div className='card'>
					<span className='card__title'>Post ads</span>
					for lost & found pets and pet services, and get notifications about
					new posts
				</div>

				<div className='card'>
					<span className='card__title'>Services</span>
					Choose a category and list your pet-related service
				</div>

				<div className='card'>
					<span className='card__title'>Set up your own profile</span>
					manage your active and archived ads
				</div>

				<div className='card'>
					<span className='card__title'>Geolocation map</span>
					find pets and services near you
				</div>
			</div>
		</Layout>
	);
};

export default Home;
